/**
 * Bandeau infos élève (Nom / Classe / Date) avec lignes pointillées pour écrire.
 */
const StudentFields = () => {
    return (
        <div className="ep-student-fields">
            <div className="ep-student-field">
                <span className="ep-student-label">Nom &amp; prénom</span>
                <span className="ep-student-line" />
            </div>
            <div className="ep-student-field">
                <span className="ep-student-label">Classe</span>
                <span className="ep-student-line" />
            </div>
            <div className="ep-student-field">
                <span className="ep-student-label">Date</span>
                <span className="ep-student-line" />
            </div>
        </div>
    );
};

export default StudentFields;
